import React from 'react';
import { UsersIcon } from 'lucide-react';
import { SPOTS_LEFT } from '../utils/checkout';
export function ScarcityBar() {
  return <div className="w-full rounded-xl border border-white/10 bg-ink-800/70 p-3.5 sm:p-4" data-id="element-58" data-mp="2yvt60inq5bv5">
      <div className="flex items-center justify-between gap-3" data-id="element-59" data-mp="2l44vukx1cxgt">
        <span className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-white/60 sm:text-xs" data-id="element-60" data-mp="2q3hfyxwivqfp">
          <UsersIcon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-61" data-mp="2b5p024n2d00z" />
          Posti al prezzo promozionale
        </span>
        <span className="shrink-0 rounded-md bg-danger/15 px-2 py-0.5 text-[11px] font-bold text-danger sm:text-xs" data-id="element-62" data-mp="2g74l3wp8r6jd">
          Solo {SPOTS_LEFT}!
        </span>
      </div>

      <div className="mt-2.5 h-2.5 w-full overflow-hidden rounded-full bg-ink-600" data-id="element-63" data-mp="275y3fkauvpoj">
        <div className="h-full rounded-full bg-accent" style={{
        width: '91%'
      }} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={91} aria-label="Posti promozionali già assegnati" data-id="element-64" data-mp="efd3wt7oriu" />
      </div>

      <p className="mt-2 text-[11px] leading-snug text-white/45 sm:text-xs" data-id="element-65" data-mp="2zm2wjna2l07v">
        91% dei posti già assegnati. Quando saranno esauriti, il prezzo tornerà al suo valore
        normale.
      </p>
    </div>;
}